import React from 'react';

import LogoIcon from 'layouts/main-sidebar/LogoIcon';
import LanguageSelector from 'ui-brand/components/LanguageSelector';

type Props = {
  // Only pages under i18n_patterns can switch language by URL.
  languageSelector?: boolean;
  children: React.ReactNode;
};

function AuthShell({ languageSelector = true, children }: Props) {
  return (
    <div className="flex min-h-dvh flex-col bg-retino-beige font-lexend antialiased">
      <header className="p-4 lg:px-8">
        <div className="mx-auto flex w-full max-w-screen-xl items-center justify-between">
          <a
            href="https://www.retino.com"
            className="flex min-h-12 items-center text-retino-darkviolet"
            aria-label="Retino"
          >
            <span className="block w-32 lg:w-40">
              <LogoIcon />
            </span>
          </a>
          {languageSelector && <LanguageSelector />}
        </div>
      </header>
      <main className="mx-auto w-full max-w-screen-xl grow px-4 lg:px-8">{children}</main>
      <footer className="px-4 py-8 text-center text-base text-retino-darkgrey sm:text-[13px]">
        &copy; 2017&ndash;{new Date().getFullYear()} Retino.cz s.r.o.
      </footer>
    </div>
  );
}

export default AuthShell;
